import React from 'react'
import { ToastContentProps } from 'react-toastify'
import { getToastTranslation } from '../../app/helpers/translationHelper';

interface IParams {
    title: string;
    toastContentProps: ToastContentProps;
}

const DownloadCompletedToast: React.FC<IParams> = ({ title, toastContentProps }) => {
    return (
        <div>
            <i className="fas fa-cloud-download-alt" aria-hidden="true"></i>
            <span className="font-weight-bold text-uppercase"> {title}: </span>
            <span> {getToastTranslation("nativeapp_download_ok")}</span>
        </div>
    )
}

export default DownloadCompletedToast;
